import Layout from '@/components/feature/Layout';
import HeroSection from './components/HeroSection';
import TrendingSection from './components/TrendingSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import FeatureSection from './components/FeatureSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '玖玖视频',
    url: 'https://www.jiujiu-video.com',
    description: '玖玖视频是一款高清流畅的在线视频平台，提供海量免费视频资源，支持多终端同步观看。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.jiujiu-video.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '玖玖视频',
    url: 'https://www.jiujiu-video.com',
    description: '玖玖视频 - 高清视频在线观看平台，海量视频资源免费观看',
  };

  return (
    <Layout>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <HeroSection />
      <TrendingSection />
      <CategorySection />
      <LatestSection />
      <FeatureSection />
      <FAQSection />
      <CTASection />
    </Layout>
  );
}